// extracted by mini-css-extract-plugin
module.exports = {"highlightsStripContainer":"GvDkR"};